/* eslint-disable multiline-ternary */
/* eslint-disable no-confusing-arrow */
// ** Third Party Components
import { Download, Eye } from 'react-feather'

// ** Table Common Column

export const columns = (toggleModal) => [
  {
    name: 'No.',
    width: '5%',
    maxWidth: '10%',
    center: true,
    selector: (row) => row.noDocument,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">
        {row.noDocument}
      </div>
    ),
  },
  {
    name: 'Nombre de Cliente',
    width: '14%',
    maxWidth: '10%',
    sortable: true,
    center: true,
    selector: (row) => row.clientName,
  },
  {
    name: 'Fecha de Creacion',
    width: '12%',
    maxWidth: '10%',
    center: true,
    sortable: true,
    selector: (row) => row.createDate,
  },
  // {
  //   name: 'Total de firmas',
  //   width: '12%',
  //   maxWidth: '10%',
  //   center: true,
  //   sortable: true,
  //   selector: (row) =>
  //     row.society === null
  //       ? 'N/A'
  //       : `${row?.society?.completed} de ${row?.society?.total}`,
  // },
  {
    name: 'Documento',
    width: '11%',
    maxWidth: '10%',
    center: true,
    sortable: true,
    selector: (row) => row.documentName,
  },
  {
    name: 'Correo del Cliente',
    width: '18%',
    maxWidth: '10%',
    center: true,
    sortable: true,
    selector: (row) => row.clientEmail,
  },
  {
    name: 'N° documento de identidad del cliente',
    width: '20%',
    maxWidth: '10%',
    center: true,
    sortable: true,
    selector: (row) => {
      const validation = row.society === null || row.society === undefined

      if (validation) {
        return row.clientIdentification
      }

      return row?.society?.taxId
    },
  },
  {
    name: 'Area',
    width: '6%',
    maxWidth: '10%',
    center: true,
    sortable: true,
    selector: (row) => row.area,
  },
  {
    name: 'Celular',
    width: '8%',
    maxWidth: '10%',
    center: true,
    sortable: true,
    selector: (row) => row.clientPhone,
  },
  {
    name: 'Acciones',
    width: '7%',
    maxWidth: '10%',
    center: true,
    allowOverflow: true,
    cell: (row) => {
      return (
        <div className="d-flex">
          <div className="pe-1 cursor-pointer">
            <a
              href={row.documentUrl}
              target={'_blank'}
              download={'file'}
            >
              <Download size={20} />
            </a>
          </div>
          <div className="cursor-pointer text-primary">
            <Eye
              onClick={() =>
                toggleModal(true, {
                  id: row.noDocument,
                  name: row.documentName,
                  client: row.clientName,
                  society: row.society,
                })
              }
              size={20}
            />
          </div>
        </div>
      )
    },
  },
]
